import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import { SvgLolUggPlus } from "@ugitgud/legos/ui/icon/SVG/LolUggPlus";
import { SvgLolUggLogoUWhite } from "@ugitgud/legos/ui/icon/SVG/LolUggLogoUWhite";
import classNames from "classnames";
import { useCallback, useState } from "react";

export interface BannerProps {
  url: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export const ALL_STAR_BANNER_CTA = "all-star-banner";

const BANNER_ART = "https://static.bigbrain.gg/assets/ugg/cta/allstar-xayah.png";

export function AllStarBanner(props: BannerProps) {
  const { url, onClick, onClose, utmSource } = props;
  const [open, setOpen] = useState(true);

  const finalUrl = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(finalUrl);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      onClose?.();
    }, 150);
  }, [onClose, setOpen]);

  return (
    <div
      className={classNames(
        "transition-all relative px-[12px] w-full overflow-hidden bg-[#292337] border-b border-lavender-50",
        open ? "h-[48px]" : "h-0",
      )}
    >
      <div
        className="absolute inset-0 bg-no-repeat bg-[size:1800px_auto] bg-[position:right_16%] max-sm:bg-[position:calc(100%_+_220px)_16%] max-xs:bg-[position:calc(100%_+_140px)_16%]"
        style={{ backgroundImage: `url(${BANNER_ART})` }}
      />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,#292337_0%,#292337_30%,rgba(41,35,55,0)_65%)] max-sm:bg-[linear-gradient(90deg,#292337_48%,rgba(41,35,55,0)_80%)] max-xs:bg-[linear-gradient(90deg,#292337_15%,rgba(41,35,55,0)_75%)]" />
      <div className="relative flex items-center justify-center gap-[18px] h-full max-md:justify-start">
        <Icon icon={<SvgLolUggLogoUWhite />} className="flex items-center w-[30px] h-[30px] max-xs:hidden" />
        <div className="[text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)] translate-y-[1px]">
          <div className="font-barlow-condensed font-bold text-[18px] text-white leading-none">NEVER MISS YOUR HIGHLIGHTS</div>
          <div className="font-inter font-medium text-[12px] text-white leading-[1.2] mt-[4px] max-xs:hidden">
            Auto-save your best plays with U.GG PLUS
          </div>
        </div>
        <a href={finalUrl} onClick={onUrlClick} className="max-xs:ml-auto">
          <div
            className={classNames(
              "flex items-center justify-center gap-[6px] px-[12px] h-[30px] rounded-[3px] whitespace-nowrap",
              "bg-accent-blue-600 border border-accent-blue-400 drop-shadow-[0px_2px_1px_rgba(0,0,0,0.25)]",
              "font-barlow-condensed text-[13px] font-bold leading-none text-white",
              "cursor-pointer hover:bg-[#2163EC]",
            )}
          >
            <span className="font-barlow-condensed">DISCOVER</span>
            <Icon icon={<SvgLolUggPlus />} className="w-[32px] h-[15px]" />
          </div>
        </a>
      </div>
      {onClose && (
        <div
          className="absolute top-[50%] right-[12px] translate-y-[-50%] p-[6px] cursor-pointer hover:opacity-80 max-xs:hidden"
          onClick={handleClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="text-[#25254B] drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
